import { breakpoint } from '@carvana/ds-styles';
import TextInput from '@carvana/ds-text-input';
import { useMediaQuery } from '@carvana/helios-utils';
import { appendTestContext, useTestFunc, withTestFunc } from '@carvana/test-attributes';
import styled from 'styled-components';
import WhereIsMyVin from '../WhereIsMyVin';

const VinForm = styled.div`
  box-sizing: border-box;
  width: 100%;
  text-align: left;

  @media screen and (min-width: ${breakpoint.md}) {
    display: flex;
  }
`;

type VinEntryProps = {
  hasError?: boolean;
  error?: string;
  updateVin: (target: React.ChangeEvent<HTMLInputElement>) => void;
  vin: string;
  wideOnDesktop?: boolean;
};

const VinEntry = ({
  hasError = false,
  error = undefined,
  updateVin,
  vin,
  wideOnDesktop = false,
  ...props
}: VinEntryProps) => {
  const getTestAttributes = useTestFunc();
  const isMobile = useMediaQuery(`(max-width: ${breakpoint.md})`);
  const desktopWidth = wideOnDesktop ? '66%' : '284px';

  return (
    <VinForm>
      <TextInput
        {...getTestAttributes('Input')}
        error={error}
        hasError={hasError}
        id="VIN"
        value={vin}
        label="VIN"
        maxLength={17}
        minLength={17}
        onChange={updateVin}
        touched={hasError || vin?.length === 17}
        width={isMobile ? '100%' : desktopWidth}
        style={{ width: isMobile ? '100%' : desktopWidth }}
        {...props}
      />
      <WhereIsMyVin />
    </VinForm>
  );
};

export default appendTestContext('VinEntry')(withTestFunc(VinEntry));
